import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Medal = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M8.178 15.41v5.907c0 .495.514.821.961.61l2.574-1.21a.67.67 0 0 1 .574 0l2.574 1.21a.675.675 0 0 0 .961-.61V15.41m2.699-5.397a6.52 6.52 0 1 1-13.042 0 6.52 6.52 0 0 1 13.042 0'
        stroke='currentColor'
        strokeWidth='1.349'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 3.493a6.706 6.706 0 0 0-4.191 11.941v5.3c0 .922.959 1.53 1.793 1.138L12 20.743l2.399 1.129a1.257 1.257 0 0 0 1.792-1.138v-5.3A6.706 6.706 0 0 0 12 3.493M9.066 16.231a6.7 6.7 0 0 0 2.934.674 6.7 6.7 0 0 0 2.934-.674v4.503l-2.399-1.128a1.25 1.25 0 0 0-1.07 0l-2.399 1.128z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
